import {
  endsWith, isEmpty, replace, startsWith,
} from 'lodash';

const childrenWildcard = '.*';
const allowAll = '*';

export const doPermissionsMatch = (
  requiredPermissions: string[],
  grantedPermissions: string[],
) => grantedPermissions.some((grantedPermission) => {
  if (grantedPermission === allowAll) {
    return true;
  }
  return requiredPermissions.some((requiredPermission) => {
    if (endsWith(grantedPermission, childrenWildcard)) {
      if (
        startsWith(requiredPermission, replace(grantedPermission, childrenWildcard, ''))
      ) {
        return true;
      }
    } else {
      return requiredPermission === grantedPermission;
    }
    return false;
  });
});

export const doesHavePermission = (
  requiredPermissions: string[],
  allowedPermissions: string[],
  disallowedPermissions: string[],
) => {
  if (isEmpty(requiredPermissions)) return true;

  const isAllowed = doPermissionsMatch(requiredPermissions, allowedPermissions);

  const isDisallowed = doPermissionsMatch(requiredPermissions, disallowedPermissions);

  return isAllowed && !isDisallowed;
};
